import type { TinderUState } from './types';

export const TINDER_U_STATUS_LIKELY = 'likely';
export const TINDER_U_STATUS_VERIFIED = 'verified';
export const TINDER_U_STATUS_VERIFIED_OPT_OUT = 'verified_opt_out';

export const getIsTinderUVerified = (tinderU: TinderUState) =>
  tinderU.status === TINDER_U_STATUS_VERIFIED;
